import { combineReducers, configureStore } from '@reduxjs/toolkit'
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

import citiesReducer from './slices/citiesSlice'
import forecastReducer from './slices/forecastSlice'

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  blackList: ['cities.options', 'cities.loading', 'cities.error', 'forecast'],
}

const rootReducer = combineReducers({
  cities: citiesReducer,
  forecast: forecastReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
})

export const persistor = persistStore(store)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>

// Inferred type: {auth: authReducer}
export type AppDispatch = typeof store.dispatch
